import { useState, useEffect } from 'react';

import { useLazyGetUsersByNicknameQuery } from '@services';

import { UserModel } from 'v2/types/UserModel';

export const useUserSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [usersData, setUsersData] = useState<UserModel[]>([]);

  const [getUsers, { isLoading: isUsersLoading }] = useLazyGetUsersByNicknameQuery();

  useEffect(() => {
    const timeoutId = setTimeout(async () => {
      if (searchQuery.length >= 2) {
        try {
          const { result } = await getUsers({ nicknames: [searchQuery], isStrictSearch: false }).unwrap();
          setUsersData(result);
        } catch (error) {
          setUsersData([]);
        }
      } else {
        setUsersData([]);
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchQuery, getUsers]);

  const clearSearch = () => {
    setSearchQuery('');
    setUsersData([]);
  };

  return {
    searchQuery,
    setSearchQuery,
    usersData,
    isUsersLoading,
    clearSearch,
  };
};
